import React from "react";

export default function Spinner({ size = 48, label = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className="animate-spin rounded-full border-4 border-gray-300 border-t-transparent"
        style={{ width: size, height: size }}
        aria-label={label}
      />
      <span className="text-sm text-gray-500 dark:text-gray-300">{label}</span>
    </div>
  );
}